export default Object.freeze({
  structure: 'STROENIE',
  building: 'SOORUZHENIE',
  letter: 'LITER',
});
